/**
 * Domain types and enums for search and hotel detail, copied out of @lmn/lmn-domainlogic 3.16.0
 * (upstream commit fe58fae). Only the modules the app uses were brought over, so the memsearch
 * contract and the promotion rules can change here without waiting for a package release.
 *
 * The five enums that @lmn/lmn-commonlogic types its own API with are the exception: they are
 * re-exported from the package rather than copied, so there is only ever one definition of them.
 * See ./common/enums.ts.
 */

export { Brand, Country, Currency, Environment, Language, LeisureType, SearchModes } from './common/enums.ts';
export { removeUndefinedValues } from './common/utils.ts';
export { MemSearchSearchModes, MEM_SEARCH_PRODUCT_THEME_NAMES } from './api/memsearch/typesMemsearch.ts';
export { getActivePromotions } from './card/getActivePromotions.ts';
export { PROMOTION_TYPES } from './types/types.ts';
export { VOUCHER_EXTRA_TYPE, VOUCHER_TYPE } from './types/typesProduct.ts';
export { JourneyContractSegmentTransportType, JourneyContractWayTransportCategory } from './journey/JourneyContract.ts';

export type { SearchAPIParams } from './api/memsearch/SearchAPIParams.ts';
export type { MemSearchAPI, MemSearchPoint } from './api/memsearch/typesMemsearch.ts';
export type { MemSearchCompareAPI } from './api/memsearch/typesMemsearchCompare.ts';
export type { JourneyContractBaggage, JourneyContractSegment, JourneyContractWay } from './journey/JourneyContract.ts';
export type { AuthResponse, AuthSucceeded } from './types/typesAuthResponse.ts';
export type { CompareProduct } from './types/typesCompareProduct.ts';
export type { ProductCounters } from './types/typesCounters.ts';
export type { Flags } from './types/typeFlags.ts';
export type {
  DistanceUsp,
  Product,
  ProductAccommodation,
  ProductAccommodationFacilities,
  ProductRate,
  ProductRateOffers,
  ProductServerOnly,
  ProductThemeName,
} from './types/typesProduct.ts';
export type { Footprint, Transport, TransportAirport, TransportData } from './types/typesTransport.ts';
